import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import './styles/variables.css'; // typography, layout, z-index tokens
import './styles/globals.css'; // color, radius, motion tokens (design system)
import './styles/mobile.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// Sentry error tracking (BLD-525). No DSN in local dev .env => no-op.
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'production',
    tracesSampleRate: 0,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
